import { Breakpoints } from 'theme';

export const COLUMNS: Record<Breakpoints, number> = {
  [Breakpoints.Mobile]: 4,
  [Breakpoints.Tablet]: 8,
  [Breakpoints.SmallDesktop]: 16,
  [Breakpoints.Desktop]: 16,
  [Breakpoints.LargeDesktop]: 16,
};
